// Generated by CoffeeScript 2.7.0
var heading, listNodes, paragraph;

import {
  nodes
} from 'prosemirror-schema-basic';

import {
  orderedList,
  bulletList,
  listItem
} from 'prosemirror-schema-list';

import {
  tableNodes
} from 'prosemirror-tables';

import {
  getAlignStyle,
  generateAlignStyle
} from './utils.js';

paragraph = {
  attrs: {
    align: {
      default: null
    }
  },
  content: 'inline*',
  group: 'block',
  parseDOM: [
    {
      tag: 'p',
      getAttrs: function(dom) {
        var align;
        align = getAlignStyle(dom);
        return {align};
      }
    }
  ],
  toDOM: function(node) {
    var align, attrs, style;
    ({align} = node.attrs);
    style = '';
    style += generateAlignStyle(align);
    attrs = {};
    if (style) {
      attrs.style = style;
    }
    return ['p', attrs, 0];
  }
};

heading = {
  attrs: {
    level: {
      default: 1
    },
    align: {
      default: null
    }
  },
  content: 'inline*',
  group: 'block',
  defining: true,
  parseDOM: [1, 2, 3, 4, 5].map(function(level) {
    return {
      tag: `h${level}`,
      getAttrs: function(dom) {
        var align;
        align = getAlignStyle(dom);
        return {level, align};
      }
    };
  }),
  toDOM: function(node) {
    var align, attrs, style;
    ({align} = node.attrs);
    style = '';
    style += generateAlignStyle(align);
    attrs = {};
    if (style) {
      attrs.style = style;
    }
    return [`h${node.attrs.level}`, attrs, 0];
  }
};

listNodes = {
  ordered_list: {
    ...orderedList,
    content: 'list_item+',
    group: 'block'
  },
  bullet_list: {
    ...bulletList,
    content: 'list_item+',
    group: 'block'
  },
  list_item: {
    ...listItem,
    content: 'paragraph block*',
    attrs: {
      align: {
        default: null
      }
    },
    parseDOM: [
      {
        tag: 'li',
        getAttrs: function(dom) {
          var align;
          align = getAlignStyle(dom);
          return {align};
        }
      }
    ],
    toDOM: function(node) {
      var align, attrs, style;
      ({align} = node.attrs);
      style = '';
      style += generateAlignStyle(align);
      attrs = {};
      if (style) {
        attrs.style = style;
      }
      return ['li', attrs, 0];
    }
  }
};

export default {...nodes, ...listNodes, ...tableNodes({
    tableGroup: 'block',
    cellContent: 'block+'
  }), paragraph, heading};
